<template>
    <div class="container mr-b4">
        <div class="title">{{"基本设置"|language}}</div>
        <div class="sub-container mr-t2">
            <div class="_left">
                <img
                    class="avatar"
                    v-real-img="form.avatar"
                    alt=""
                >
                <Upload
                    class="mr-t3"
                    ref="upload"
                    multiple
                    :show-upload-list="false"
                    :data="qnUploadData"
                    :before-upload="beforeFileUpload"
                    :on-success="handleSelectFile"
                    action="https://upload.qbox.me"
                >
                    <Button
                        type="primary"
                        size="large"
                    >
                        {{"更换头像"|language}}</Button>
                </Upload>
            </div>
            <div class="_right">
                <Form :model="form">
                    <FormItem>
                        <div class="_title mr-b1">{{"邮箱"|language}}</div>
                        <Input
                            v-model="form.email"
                            :placeholder="'请输入邮箱'|language"
                        ></Input>
                    </FormItem>
                    <FormItem>
                        <div class="_title mr-b1">{{"昵称"|language}}</div>
                        <Input
                            v-model="form.nickname"
                            :placeholder="'请输入昵称'|language"
                        ></Input>
                    </FormItem>
                    <FormItem>
                        <div class="_title mr-b1">{{"个人简介"|language}}</div>
                        <Input
                            type="textarea"
                            :autosize="{minRows:4}"
                            v-model="form.intro "
                            :placeholder="'请输入个人简介'|language"
                        ></Input>
                    </FormItem>
                    <FormItem>
                        <div class="_title mr-b1">{{"企业信息"|language}}</div>
                        <Input
                            :autosize="{minRows:4}"
                            type="textarea"
                            v-model="form.companyInfo"
                            :placeholder="'请输入企业信息'|language"
                        ></Input>
                    </FormItem>
                    <FormItem>
                        <div class="_title mr-b1">{{"所在地址"|language}}</div>
                        <Input
                            v-model="form.companyAddr"
                            :placeholder="'请输入所在地址'|language"
                        ></Input>
                    </FormItem>
                    <FormItem>
                        <div class="_title mr-b1">{{"联系电话"|language}}</div>
                        <Input
                            v-model="form.phone"
                            disabled
                            :placeholder="'请输入联系电话'|language"
                        ></Input>
                    </FormItem>
                    <FormItem>
                        <Button
                            type="primary"
                            @click="handleSubmit"
                        >{{"更新信息"|language}}</Button>
                    </FormItem>
                </Form>
            </div>
        </div>

    </div>
</template>

<script>
import uuidv1 from "uuid/v1";
import { qiniuUploadMixin } from "../../mixin/qiniuUpload";
import { languageTranslation } from "../../assets/util/language";
export default {
  mixins: [qiniuUploadMixin],
  data() {
    return {
      form: {
        avatar: ""
      }
    };
  },
  created() {
    // let admin = JSON.parse(JSON.stringify(localStorage.getItem("set_admin")));
    if (this.admin) {
      this.form = { ...this.admin };
      if ("avatar" in this.admin) {
        this.form.avatar = this.admin.avatar.src;
      }
    } else {
      this.$router.push("/common/login");
    }
  },
  methods: {
    //上传部分
    beforeFileUpload(file) {
      let ext = file.name.split(".").reverse()[0];
      if (!ext) {
        this.$Message.error({
          background: true,
          content: languageTranslation("不支持无后缀名文件上传")
        });
      }

      this.qnUploadData.key = `${uuidv1()}.${ext}`;
      let isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$Message.error({
          background: true,
          content: `${languageTranslation("上传头像大小不能超过")}2MB`
        });
        return false;
      }

      return isLt2M;
    },
    handleSelectFile(res, file) {
      let src = this.joinCDN(res.key);
      this.$set(this.form, "avatar", src);
      // this.form.avatar = src;
      //   this.uploadFile(src, file.name, file.size);
    },
    // async uploadFile(src, name, size) {
    //   // this.$Spin.show();
    //   await this.httpFileUpload(src, name, size);
    //   // this.$Spin.hide();
    // },
    // async httpFileUpload(src, name, size) {
    //   let type = name.split(".").reverse()[0];
    //   name = name.split(".").reverse()[1];
    //   let data = {
    //     folder: this.selectedFolder,
    //     src,
    //     type,
    //     name,
    //     permiss: 3,
    //     size
    //   };
    //   this.$Message.success(`${languageTranslation("上传成功")}`);
    //   let file = await HttpUtil.post("/filestore", data);
    //   this.info.fileList.push(file);
    //   this.info.fileList = [...new Set([...this.info.fileList])];
    // }
    async handleSubmit() {
      if (!this.admin)
        return this.$Message.error(languageTranslation("登录失效，请重新登录"));
      let res = await this.$http.put("/user/info", this.form);
      this.$store.dispatch("loginState", res);
      this.$Message.success(languageTranslation("更新成功!"));
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  .title {
    opacity: 0.9;
    font-size: 30px;
    line-height: 32px;
    text-align: left;
  }
  .sub-container {
    display: flex;
    align-items: flex-start;
    ._left {
      .avatar {
        width: 125px;
        height: 125px;
        border-radius: 50%;
        background-color: #d8d8d8;
        object-fit: cover;
      }
    }
    ._right {
      margin-left: 80px;
      width: 470px;
      text-align: left;
      font-size: 18px;
      ._title {
        font-size: 18px;
        text-align: left;
      }
    }
  }
}
</style>